"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Box = _interopRequireDefault(require("../Box"));

var _StackStyles = require("./Stack-styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Columns(props) {
  if (!(0, _StackStyles.isColumnsAllowed)(props)) {
    return props.children;
  }

  function boxForEmptySpaces(numberOfColumns, numberOfItems) {
    let divideRemaining = numberOfItems % numberOfColumns;
    let extraBox = numberOfColumns - divideRemaining;
    let boxes = [];

    if (numberOfColumns !== extraBox) {
      boxes = new Array(extraBox).fill("box");
    }

    let boxWidth = `${90 / numberOfColumns}%`;
    return boxes.map(() => {
      return /*#__PURE__*/_react.default.createElement(_Box.default, {
        style: {
          width: boxWidth,
          height: 100
        }
      });
    });
  }

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _react.default.Children.map(props.children, (item, index) => {
    let column_idx = index > 0 ? index % props.columns.length : 0;
    let isFirstChild = index % props.columns.length === 0;
    let isLastChild = index % props.columns.length === props.columns.length - 1;
    let gap = props.gap ? props.gap / 2 : 0;
    let margin_right = isFirstChild ? 0 : gap;
    let margin_left = isLastChild ? 0 : gap;
    return /*#__PURE__*/_react.default.createElement(_Box.default, {
      style: {
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: props.columns[column_idx],
        marginRight: margin_right,
        marginLeft: margin_left
      }
    }, item);
  }), props.fillIfEmpty ? boxForEmptySpaces(props.columns.length, props.children.length) : null);
}

var _default = Columns;
exports.default = _default;